import React from 'react';
import SelectPopup from './SelectPopup';
import { initModule as init } from '../../../service/command';
import { filterDetectModules } from '../../../js/utils';

const modules = [
  'radar',
  'geo'
];

export default function InitModule() {
  const targets = filterDetectModules(modules);

  return (
    <SelectPopup
      title="重启"
      modules={targets}
      defaultSelectValue={targets[0]}
      onConfirm={(module) => {
        return init(module);
      }}
    />
  );
}
